import React from 'react';
import CommonIcon from '../helpers/icons';
import { CreateAccountapi, verifyEmail } from '../../action/createaccountapi';
import withRouter from "../custom/withRouter";
import { connect } from "react-redux";

class CreateAccount extends React.Component {

    constructor() {
        super()
        this.state = {
            name: '',
            lastName: '',
            email: '',
            phone: '',
            nameError: '',
            lastNameError: '',
            emailError: '',
            phoneError: '',
            organizationName: '',
            organizationNameError: '',
            password: '',
            conformPassword: '',
            conformPasswordError: '',
            passwordError: '',
            showPassword: false,
            showConformPassword: false,
            select: '91',
            isWebMobile:false
        }
    }
    componentDidMount = () => {
        
        const intervals = setInterval(() => {
            this.resize();
        }, 10)
        console.log('HELLO');
    }
    handleValidate = () => {
        if (this.state.name == "") {
            this.state.nameError = 'First Name is missing.';    // document.getElementById('name').style.borderColor='red'
        }
        else {
            this.state.nameError = '';
        }
        if (this.state.lastName == "") {
            this.state.lastNameError = 'Last Name is missing.';    // document.getElementById('name').style.borderColor='red'
        }
        else {
            this.state.lastNameError = '';
        }
        if (this.state.email == "") {
            this.state.emailError = 'Email is missing.';    // document.getElementById('name').style.borderColor='red'
        }
        else {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (emailRegex.test(this.state.email)) {
                this.state.emailError = '';
            }
            else {
                this.state.emailError = 'Invalid email.'
            }

        }
        if (this.state.phone == "") {
            this.state.phoneError = 'Phone Number is missing.';    // document.getElementById('name').style.borderColor='red'
        }
        else {
            this.state.phoneError = '';
        }
        if (this.state.organizationName == "") {
            this.state.organizationNameError = 'Organization Name is missing.'
        }
        else {
            this.state.organizationNameError = '';
        }

        if (this.state.password == "") {
            this.state.passwordError = 'Password is missing.'
        }
        else {


            const regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
            if (regex.test(this.state.password)) {
                this.state.passwordError = '';
            }
            else {
                this.state.passwordError = 'Include uppercase and lowercase letters, a number, and a special character (!@#$%^&*).';
            }
        }
        if (this.state.conformPassword == "") {
            this.state.conformPasswordError = 'Confirm Password is missing.'
        }
        else {
            if (this.state.password != this.state.conformPassword) {
                this.state.conformPasswordError = 'Password mismatch.'
            }
            else {
                this.state.conformPasswordError = '';
            }

        }
    }
    handleSubmit = async () => {
        
        this.handleValidate();
        console.log(this.state.select, this.state.phone);
        let phonenumber = this.state.select + "-" + this.state.phone;
        console.log(phonenumber);

        if (this.state.name != "" && this.state.lastName != "" && this.state.email != "" && this.state.organizationName != "" && this.state.password != "" && this.state.conformPassword != "" && this.state.password == this.state.conformPassword) {
            console.log(this.state.name, this.state.email, this.state.organizationName, this.state.password, this.state.conformPassword);
            let createaccountvalues = {
                "firstName": this.state.name,
                // "name":this.state.name,
                "lastName": this.state.lastName,
                "email": this.state.email,
                "phoneNumber": phonenumber ? phonenumber : '',
                "organizationName": this.state.organizationName,
                "password": this.state.password,
                "confirmPassword": this.state.conformPassword
            }
            console.log(createaccountvalues);

            this.props.dispatch(CreateAccountapi(createaccountvalues))
        }
    }
    togglePasswordVisibility = () => {
        this.setState({ showPassword: !this.state.showPassword })
    };

    toggleConformPasswordVisibility = () => {
        this.setState({ showConformPassword: !this.state.showConformPassword })
    };

    navigate = () => {
        window.location.href = "/login"
    }
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true,


            })
        } else {
            this.setState({
                isMobile: false,
                isWebMobile: false
            })
        }

        if (window.innerWidth < 600) {
            this.setState({
                isMobile600: true,
                isWebMobile: true
            })
        } else {
            this.setState({
                isMobile600: false,
                isWebMobile: false
            })
        }

        if (window.innerWidth < 380) {
            this.setState({
                isMobile380: true
            })
            this.setState({
                isMobile380: true
            })
        } else {
            this.setState({
                isMobile380: false
            })
        }
        this.setState({
            height: window.innerHeight
        })
    };

    render() {
        //  console.log(this.state.name);
        const {isWebMobile}=this.state
        return (
            isWebMobile?
            <div className='main'>
                <div className='w-100 h-100'>
                    <div className='tpcontent'>
                        <div className='pl-3'>
                            <CommonIcon fileName={'Flazlogo'} />&nbsp;
                        </div>
                        <div className='log-in'>
                            
                            <button type='submit' className='redirect-login' onClick={this.navigate}>Login</button>
                        </div>
                    </div>

                    <div className='submainmobile mt-5'>

                        <div className='formmobile '>
                            <div className='header w-100'>
                                <label className='title-createmobile'>Create an account</label>
                            </div>
                            <div className='input h-100'>
                                <div className=' w-100 gap-4 align-items-start'>

                                    <div className='w-100'>
                                        <label className='label'>First Name </label><span className='isrequired'>*</span><br />
                                        <div style={{ border: this.state.nameError ? '1px solid red' : '1px solid #ebeaea', paddingLeft: '5px' }} className='w-100 d-flex'>

                                            <CommonIcon fileName={'personcreate'} />&nbsp;
                                            <input
                                                onError={this.state.nameError}
                                                value={this.state.name}
                                                id='name'
                                                // onChange={(e) => this.setState({ name: e.target.value })}
                                                onChange={(e) => {
                                                    const filteredValue = e.target.value.replace(/[^a-zA-Z]/g, '');
                                                    this.setState({ name: filteredValue });
                                                }}
                                
                                                type='text'
                                                placeholder='First Name'
                                                style={{ width: "90%", height: "40px", alignItems: 'center', border: 'none', outline: 'none', fontSize: '13px', fontFamily: "Poppins" }}
                                            />

                                        </div>
                                        <span className='error'>{this.state.nameError ? this.state.nameError : ''} </span>
                                    </div>
                                    <div className='w-100'>
                                        <label className='label'>Last Name </label><span className='isrequired'>*</span><br />
                                        <div style={{ border: this.state.lastNameError ? '1px solid red' : '1px solid #ebeaea', paddingLeft: '5px' }} className='w-100 d-flex'>

                                            <CommonIcon fileName={'personcreate'} />&nbsp;
                                            <input
                                                onError={this.state.lastNameError}
                                                value={this.state.lastName}
                                                id='name'
                                                // onChange={(e) => this.setState({ lastName: e.target.value })}
                                                onChange={(e) => {
                                                    const filteredValue = e.target.value.replace(/[^a-zA-Z]/g, '');
                                                    this.setState({ lastName: filteredValue });
                                                }}
                                                type='text'
                                                placeholder='Last Name'
                                                style={{ width: "90%", height: "40px", alignItems: 'center', border: 'none', outline: 'none', fontSize: '13px', fontFamily: "Poppins" }}
                                            />

                                        </div>
                                        <span className='error'>{this.state.lastNameError ? this.state.lastNameError : ''} </span>
                                    </div>
                                </div>
                                <div className='w-100'>
                                    <label className='label'>Work Email Address </label><span className='isrequired'>*</span><br />
                                    <div style={{ border: this.state.emailError ? '1px solid red' : '1px solid #ebeaea', paddingLeft: '5px' }} className='w-100'>
                                        <CommonIcon fileName={'mail'} />&nbsp;
                                        <input
                                            id='Create-email'
                                            value={this.state.email}
                                            type='text'
                                            onChange={(e) => this.setState({ email: e.target.value })}
                                            placeholder='Enter your email'
                                            style={{ width: "90%", height: "40px", alignItems: 'center', border: 'none', outline: 'none', fontSize: '13px', fontFamily: "Poppins", }}
                                        />

                                    </div>
                                    <span className='error'>{this.state.emailError ? this.state.emailError : ''}</span>
                                </div>

                                <div className='w-100'>
                                    <label className='label'>Phone Number </label><br />
                                    <div style={{ border: '1px solid #ebeaea', display: 'flex' }} className='w-100'>
                                        <select className='noborder outline-none' value={this.state.select} onChange={(e) => this.setState({ select: e.target.value })}>
                                            <option value='91'>+91</option>
                                            <option value='65'>+65</option>
                                            <option value='70'>+70</option>
                                        </select>
                                        <input
                                            id='phone'
                                            value={this.state.phone}
                                            type='tel'
                                            placeholder=''
                                            onChange={(e) => {
                                               
                                                const filteredValue = e.target.value.replace(/[^0-9]/g, '');
                                                this.setState({ phone: filteredValue });
                                            }}
                                            style={{ width: "90%", height: "40px", alignItems: 'center', border: 'none', outline: 'none', fontSize: '13px' }}
                                        />

                                    </div>
                                </div>
                                <div className='w-100'>
                                    <label className='label'>Organization Name </label><span className='isrequired'>*</span><br />
                                    <div style={{ border: this.state.organizationNameError ? '1px solid red' : '1px solid #ebeaea', paddingLeft: '5px' }}>
                                        <CommonIcon fileName={'Apartment'} /> &nbsp;
                                        <input
                                            id='orgname'
                                            value={this.state.organizationName}
                                            type='text'
                                            onChange={(e) => this.setState({ organizationName: e.target.value })}
                                            placeholder='Organization Name'
                                            style={{ width: "90%", height: "40px", alignItems: 'center', border: 'none', outline: 'none', fontSize: '13px', fontFamily: "Poppins", marginLeft: '-5px' }}
                                        />
                                    </div>
                                    <span className='error'>{this.state.organizationNameError ? this.state.organizationNameError : ''}</span>
                                </div>
                                <div className=' w-100 gap-4 align-items-start'>
                                    <div className='w-100'>
                                        <label className='label'>Password</label><span className='isrequired'>*</span><br />
                                        <div style={{ border: this.state.passwordError ? '1px solid red' : '1px solid #ebeaea', paddingLeft: '5px', display: 'flex' }}>
                                            <CommonIcon fileName={'Lockpassword'} /> &nbsp;
                                            <input
                                                id='password'
                                                value={this.state.password}
                                                type={this.state.showPassword ? 'text' : 'password'}
                                                onChange={(e) => this.setState({ password: e.target.value })}
                                                placeholder='Password'
                                                style={{ width: "90%", height: "40px", alignItems: 'center', border: 'none', outline: 'none', fontSize: '13px', fontFamily: "Poppins" }}
                                            />
                                            <button className='border-none' onClick={this.togglePasswordVisibility}>{this.state.showPassword ? <CommonIcon fileName={'passwordvisible'} /> : <CommonIcon fileName={'passwordvisibleoff'} />}</button>
                                        </div>
                                        <span className='error'>{this.state.passwordError ? this.state.passwordError : ''}</span>
                                    </div>
                                    <div className='w-100'>
                                        <label className='label'>Confirm Password<span className='isrequired' style={{ display: 'inline' }}>*</span></label><br />
                                        <div style={{ border: this.state.conformPasswordError ? '1px solid red' : '1px solid #ebeaea', paddingLeft: '5px', display: 'flex' }}>
                                            <CommonIcon fileName={'Lockpassword'} /> &nbsp;
                                            <input
                                                id='confirm'
                                                value={this.state.conformPassword}
                                                type={this.state.showConformPassword ? 'text' : 'password'}
                                                onChange={(e) => this.setState({ conformPassword: e.target.value })}
                                                placeholder='Confirm Password'
                                                style={{ width: "90%", height: "40px", alignItems: 'center', border: 'none', outline: 'none', fontSize: '13px', fontFamily: "Poppins" }}
                                            />
                                            <button className='border-none' onClick={this.toggleConformPasswordVisibility}>{this.state.showConformPassword ? <CommonIcon fileName={'passwordvisible'} /> : <CommonIcon fileName={'passwordvisibleoff'} />}</button>
                                        </div>
                                        <span className='error'>{this.state.conformPasswordError ? this.state.conformPasswordError : ''}</span>
                                    </div>

                                </div>
                            </div>
                            <div className='btnpara w-100'>
                                <p className='para '>By clicking next, you agree to the <span className='isblue'> FLAZ Terms & Conditions</span> and <span className='isblue'>Privacy Policy.</span></p>
                                <button className='createbtn ' type='' onClick={this.handleSubmit}>Next</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            :

            <div className='main'>
                <div className='w-100 h-100'>
                    <div className='tpcontent'>
                        <div className='pl-3'>
                            <CommonIcon fileName={'Flazlogo'} />&nbsp;
                        </div>
                        <div className='log-in'>
                            <label className='text-light '>Already have an account?</label>
                            <button type='submit' className='redirect-login' onClick={this.navigate}>Login</button>
                        </div>
                    </div>

                    <div className='submain'>

                        <div className='form'>
                            <div className='header w-100'>
                                <label className='title-create'>Create an account</label>
                            </div>
                            <div className='input h-100'>
                                <div className='d-flex w-100 gap-4 align-items-start'>

                                    <div className='w-100'>
                                        <label className='label'>First Name </label><span className='isrequired'>*</span><br />
                                        <div style={{ border: this.state.nameError ? '1px solid red' : '1px solid #ebeaea', paddingLeft: '5px' }} className='w-100 d-flex'>

                                            <CommonIcon fileName={'personcreate'} />&nbsp;
                                            <input
                                                onError={this.state.nameError}
                                                value={this.state.name}
                                                id='name'
                                                // onChange={(e) => this.setState({ name: e.target.value })}
                                                onChange={(e) => {
                                                    const filteredValue = e.target.value.replace(/[^a-zA-Z]/g, '');
                                                    this.setState({ name: filteredValue });
                                                }}
                                
                                                type='text'
                                                placeholder='First Name'
                                                style={{ width: "90%", height: "40px", alignItems: 'center', border: 'none', outline: 'none', fontSize: '13px', fontFamily: "Poppins" }}
                                            />

                                        </div>
                                        <span className='error'>{this.state.nameError ? this.state.nameError : ''} </span>
                                    </div>
                                    <div className='w-100'>
                                        <label className='label'>Last Name </label><span className='isrequired'>*</span><br />
                                        <div style={{ border: this.state.lastNameError ? '1px solid red' : '1px solid #ebeaea', paddingLeft: '5px' }} className='w-100 d-flex'>

                                            <CommonIcon fileName={'personcreate'} />&nbsp;
                                            <input
                                                onError={this.state.lastNameError}
                                                value={this.state.lastName}
                                                id='name'
                                                // onChange={(e) => this.setState({ lastName: e.target.value })}
                                                onChange={(e) => {
                                                    const filteredValue = e.target.value.replace(/[^a-zA-Z]/g, '');
                                                    this.setState({ lastName: filteredValue });
                                                }}
                                                type='text'
                                                placeholder='Last Name'
                                                style={{ width: "90%", height: "40px", alignItems: 'center', border: 'none', outline: 'none', fontSize: '13px', fontFamily: "Poppins" }}
                                            />

                                        </div>
                                        <span className='error'>{this.state.lastNameError ? this.state.lastNameError : ''} </span>
                                    </div>
                                </div>
                                <div className='w-100'>
                                    <label className='label'>Work Email Address </label><span className='isrequired'>*</span><br />
                                    <div style={{ border: this.state.emailError ? '1px solid red' : '1px solid #ebeaea', paddingLeft: '5px' }} className='w-100'>
                                        <CommonIcon fileName={'mail'} />&nbsp;
                                        <input
                                            id='Create-email'
                                            value={this.state.email}
                                            type='text'
                                            onChange={(e) => this.setState({ email: e.target.value })}
                                            placeholder='Enter your email'
                                            style={{ width: "90%", height: "40px", alignItems: 'center', border: 'none', outline: 'none', fontSize: '13px', fontFamily: "Poppins", }}
                                        />

                                    </div>
                                    <span className='error'>{this.state.emailError ? this.state.emailError : ''}</span>
                                </div>

                                <div className='w-100'>
                                    <label className='label'>Phone Number </label><br />
                                    <div style={{ border: '1px solid #ebeaea', display: 'flex' }} className='w-100'>
                                        <select className='noborder outline-none' value={this.state.select} onChange={(e) => this.setState({ select: e.target.value })}>
                                            <option value='91'>+91</option>
                                            <option value='65'>+65</option>
                                            <option value='70'>+70</option>
                                        </select>
                                        <input
                                            id='phone'
                                            value={this.state.phone}
                                            type='tel'
                                            placeholder=''
                                            onChange={(e) => {
                                               
                                                const filteredValue = e.target.value.replace(/[^0-9]/g, '');
                                                this.setState({ phone: filteredValue });
                                            }}
                                            style={{ width: "90%", height: "40px", alignItems: 'center', border: 'none', outline: 'none', fontSize: '13px' }}
                                        />

                                    </div>
                                </div>
                                <div className='w-100'>
                                    <label className='label'>Organization Name </label><span className='isrequired'>*</span><br />
                                    <div style={{ border: this.state.organizationNameError ? '1px solid red' : '1px solid #ebeaea', paddingLeft: '5px' }}>
                                        <CommonIcon fileName={'Apartment'} /> &nbsp;
                                        <input
                                            id='orgname'
                                            value={this.state.organizationName}
                                            type='text'
                                            onChange={(e) => this.setState({ organizationName: e.target.value })}
                                            placeholder='Organization Name'
                                            style={{ width: "90%", height: "40px", alignItems: 'center', border: 'none', outline: 'none', fontSize: '13px', fontFamily: "Poppins", marginLeft: '-5px' }}
                                        />
                                    </div>
                                    <span className='error'>{this.state.organizationNameError ? this.state.organizationNameError : ''}</span>
                                </div>
                                <div className='d-flex w-100 gap-4 align-items-start'>
                                    <div className='w-100'>
                                        <label className='label'>Password</label><span className='isrequired'>*</span><br />
                                        <div style={{ border: this.state.passwordError ? '1px solid red' : '1px solid #ebeaea', paddingLeft: '5px', display: 'flex' }}>
                                            <CommonIcon fileName={'Lockpassword'} /> &nbsp;
                                            <input
                                                id='password'
                                                value={this.state.password}
                                                type={this.state.showPassword ? 'text' : 'password'}
                                                onChange={(e) => this.setState({ password: e.target.value })}
                                                placeholder='Password'
                                                style={{ width: "90%", height: "40px", alignItems: 'center', border: 'none', outline: 'none', fontSize: '13px', fontFamily: "Poppins" }}
                                            />
                                            <button className='border-none' onClick={this.togglePasswordVisibility}>{this.state.showPassword ? <CommonIcon fileName={'passwordvisible'} /> : <CommonIcon fileName={'passwordvisibleoff'} />}</button>
                                        </div>
                                        <span className='error'>{this.state.passwordError ? this.state.passwordError : ''}</span>
                                    </div>
                                    <div className='w-100'>
                                        <label className='label'>Confirm Password<span className='isrequired' style={{ display: 'inline' }}>*</span></label><br />
                                        <div style={{ border: this.state.conformPasswordError ? '1px solid red' : '1px solid #ebeaea', paddingLeft: '5px', display: 'flex' }}>
                                            <CommonIcon fileName={'Lockpassword'} /> &nbsp;
                                            <input
                                                id='confirm'
                                                value={this.state.conformPassword}
                                                type={this.state.showConformPassword ? 'text' : 'password'}
                                                onChange={(e) => this.setState({ conformPassword: e.target.value })}
                                                placeholder='Confirm Password'
                                                style={{ width: "90%", height: "40px", alignItems: 'center', border: 'none', outline: 'none', fontSize: '13px', fontFamily: "Poppins" }}
                                            />
                                            <button className='border-none' onClick={this.toggleConformPasswordVisibility}>{this.state.showConformPassword ? <CommonIcon fileName={'passwordvisible'} /> : <CommonIcon fileName={'passwordvisibleoff'} />}</button>
                                        </div>
                                        <span className='error'>{this.state.conformPasswordError ? this.state.conformPasswordError : ''}</span>
                                    </div>

                                </div>
                            </div>
                            <div className='btnpara w-100'>
                                <p className='para '>By clicking next, you agree to the <span className='isblue'> FLAZ Terms & Conditions</span> and <span className='isblue'>Privacy Policy.</span></p>
                                <button className='createbtn ' type='' onClick={this.handleSubmit}>Next</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return { dispatch };
}

function mapStateToProps(state) {
    return {

        CreateAccountapi: state.createAccountReducer.CreateAccountapi,
        verifyEmail: state.createAccountReducer.verifyEmail,
        isLoading: state.commonReducer.isLoading,

    };
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CreateAccount)
);